(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race/create-race-handler-base.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race/create-race-handler-base.js');
'use strict';

const {
  createRaceModel,
  isRaceModel,
  getRaceId
} = svs.components.sport.raceHandler.race;
const {
  normalizeRaceModel
} = svs.components.sport.raceHandler.race;
const logger = svs.components.sport.raceHandler.logger;
const getDrawPath = drawNumber => "/racing/1/race/draw/".concat(drawNumber);
const createModelCollection = () => {
  const models = new Map();
  const addModel = raceData => {
    const raceModel = createRaceModel();
    raceModel.setData(raceData);
    if (!isRaceModel(raceModel)) {
      throw new Error('Race model must be provided');
    }
    const raceId = getRaceId(raceModel.getProductId(), raceModel.getDrawNumber());
    models.set(raceId, raceModel);
    return raceModel;
  };
  const setModel = raceModel => {
    if (!isRaceModel(raceModel)) {
      throw new Error('Race model must be provided');
    }
    models.set(raceModel.getRaceId(), raceModel);
  };
  const getCollection = () => models;
  const getModel = raceId => models.get(raceId);
  const getSerializeModel = () => {
    const racesObj = {};
    for (const [raceId, race] of models.entries()) {
      racesObj[raceId] = {
        model: race.getData(),
        timestamp: race.getTimestamp()
      };
    }
    return racesObj;
  };
  const clear = () => {
    models.clear();
  };
  return {
    addModel,
    setModel,
    getCollection,
    getSerializeModel,
    getModel,
    clear
  };
};
const createRaceHandlerBase = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  privateInterface.raceCache = createModelCollection();
  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    publicInterface.fetch = async (productId, drawNumber, shouldForceFetch) => {
      var _data;
      const productPath = getDrawPath(drawNumber);
      const raceId = getRaceId(productId, drawNumber);
      let race = privateInterface.raceCache.getModel(raceId);
      if (!shouldForceFetch && race && !race.isOutdated()) {
        return race;
      }

      let data;
      try {
        data = await privateInterface.jupiter(productPath, {
          method: 'GET'
        });
      } catch (err) {
        logger.warn("Failed fetching race with drawNumber: ".concat(drawNumber, ". Error: ").concat(err));
        throw new Error("Failed fetching race with drawNumber: ".concat(drawNumber));
      }
      if ((_data = data) !== null && _data !== void 0 && _data.race) {
        const normalizedRaceModel = normalizeRaceModel({
          drawNumber,
          productId,
          data: data.race
        });
        race = privateInterface.raceCache.addModel(normalizedRaceModel);
      }
      return race;
    };
    publicInterface.get = (productId, drawNumber) => {
      const raceId = getRaceId(productId, drawNumber);
      const race = privateInterface.raceCache.getModel(raceId);
      return race;
    };
    publicInterface.getModel = () => privateInterface.raceCache.getSerializeModel();
    publicInterface.destroy = () => {
      privateInterface.raceCache.clear();
    };
    return publicInterface;
  };
};
setGlobal('svs.components.sport.raceHandler.race.createRaceHandlerBase', createRaceHandlerBase);

 })(window);